(function () {
  "use strict";

  var data = window.__carRewardsData || { progress: 0, completedCards: 0, tier: "bronze", justCompleted: false };

  function fillDots() {
    var dots = document.querySelectorAll("[data-car-dots] .car-dot__fill");
    dots.forEach(function (dot, index) {
      // léger décalage pour que le remplissage se lise comme une séquence, pas un bloc figé
      setTimeout(function () {
        dot.style.width = index < data.progress ? "100%" : "0%";
      }, index * 90);
    });
  }

  function launchConfetti() {
    var canvas = document.querySelector("[data-car-confetti]");
    if (!canvas) return;
    var ctx = canvas.getContext("2d");
    var dpr = window.devicePixelRatio || 1;
    canvas.width = window.innerWidth * dpr;
    canvas.height = window.innerHeight * dpr;
    canvas.style.width = window.innerWidth + "px";
    canvas.style.height = window.innerHeight + "px";
    ctx.scale(dpr, dpr);

    var colors = ["#D8B45E", "#F4E2A8", "#B3763F", "#F5F5F7", "#E0B078"];
    var pieces = [];
    var count = 90;

    for (var i = 0; i < count; i++) {
      pieces.push({
        x: window.innerWidth / 2,
        y: window.innerHeight / 2,
        vx: (Math.random() - 0.5) * 9,
        vy: Math.random() * -8 - 3,
        size: Math.random() * 6 + 4,
        color: colors[Math.floor(Math.random() * colors.length)],
        rotation: Math.random() * 360,
        vr: (Math.random() - 0.5) * 12,
        gravity: 0.28
      });
    }

    var start = null;
    function frame(ts) {
      if (!start) start = ts;
      var elapsed = ts - start;
      ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);

      pieces.forEach(function (p) {
        p.vy += p.gravity;
        p.x += p.vx;
        p.y += p.vy;
        p.rotation += p.vr;

        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate((p.rotation * Math.PI) / 180);
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.size / 2, -p.size / 2, p.size, p.size * 0.6);
        ctx.restore();
      });

      if (elapsed < 2200) {
        requestAnimationFrame(frame);
      } else {
        ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
      }
    }
    requestAnimationFrame(frame);
  }

  function showCelebration() {
    var overlay = document.querySelector("[data-car-celebrate]");
    var countEl = document.querySelector("[data-car-celebrate-count]");
    if (!overlay) return;
    if (countEl) {
      countEl.textContent = "Carte complétée : " + data.completedCards + (data.completedCards === 1 ? " carte" : " cartes");
    }
    launchConfetti();
    requestAnimationFrame(function () {
      overlay.classList.add("car-visible");
    });
    overlay.addEventListener("click", function () {
      overlay.classList.remove("car-visible");
    });
    setTimeout(function () {
      overlay.classList.remove("car-visible");
    }, 4200);
  }

  document.addEventListener("DOMContentLoaded", function () {
    var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduceMotion) {
      var dots = document.querySelectorAll("[data-car-dots] .car-dot__fill");
      dots.forEach(function (dot, index) {
        dot.style.transition = "none";
        dot.style.width = index < data.progress ? "100%" : "0%";
      });
    } else {
      fillDots();
    }

    if (data.justCompleted) {
      setTimeout(showCelebration, 500);
    }
  });
})();